import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import gamblerCut from "./gamblerCut";
import gamblerGameClean from "./gamblerGameClean";
import { GamblerDataSaveType, gamblerEndInterface, gamblerEndMap, gamblerEventMap, gamblerStartInterface, gamblerStartMap, TreasureMapCollect } from "./gamblerGameConst";
import gamblerGameObj from "./gamblerGameObj";
import gameConfig from "../../../../engines/configs/gameConfig";
import gamblerExplain from "./gamblerExplain";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import utilsModel from "../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../define/MessageEventKind";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";

const {ccclass, property} = cc._decorator;

@ccclass
export default class gamblerGame extends cc.Component {

    @property({ type: cc.Node, displayName:'' })
	nodeCollect: cc.Node = null;

    @property({type:cc.Node,displayName:"center"})
    center:cc.Node = null;

    @property({type:cc.Prefab,displayName:"木头预制体"})
    objPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"objLayout"})
    objLayout:cc.Node = null;

    // gamblerEventMap:gamblerEventMap = {};
    gamblerStartMap:GamblerBasicMap = {};
    gamblerEndMap :gamblerEndMap = {};

    // gamblerEventJson = [];
    gamblerStartJson = [];
    gamblerEndJson = [];

    // gamblerLuckyEndJson = [];
    // gamblerLuckyEndMap:gamblerEndMap = {};

    oneVecAry:cc.Vec2[] = [cc.v2(-237,-352),cc.v2(0,-352),cc.v2(237,-352)];
    twoVecAry:cc.Vec2[] = [cc.v2(-237,-163),cc.v2(0,-163),cc.v2(237,-163)];
    threeVecAry:cc.Vec2[] = [cc.v2(-189,0),cc.v2(189,0)];
    fourVecAry:cc.Vec2[] = [cc.v2(0,163)];


    objAry:{startObj:gamblerStartInterface,endObj:gamblerEndInterface}[][] = [];

    vecAry:cc.Vec2[][] = [this.oneVecAry,this.twoVecAry,this.threeVecAry,this.fourVecAry];

    eventPro:number = 0.1;

    private gamblerSaveKey:string = GamblerDataSaveType.GAMBLER_SAVE_KEY;

    private gamblerDaySaveKey:string = GamblerDataSaveType.GAMBLER_DAT_SAVE_KEY;

    loadSaveGambler(){
        let g = O1HD.getServices().localStorageSrv.getStorage(this.gamblerSaveKey);
        if(!g || g == ""){
            this.loadGamblerObjs().then();
            this.checkDayIsVaild();
        }else{
            if(this.checkDayIsVaild()){
                this.objAry = JSON.parse(g)
                this.loadSaveLayoutObj();
            }else{
                this.loadGamblerObjs().then();
            }
        }
    }

    checkDayIsVaild(){
        let isVaild = O1HD.getServices().localStorageSrv.getStorage(this.gamblerDaySaveKey) == data_control.getCurrDateDayString();
        if(!isVaild){
            O1HD.getServices().localStorageSrv.setStorage(this.gamblerDaySaveKey,data_control.getCurrDateDayString());
        }
        return isVaild;
    }

    start(){
        this.gamblerStartMap = new GamblerBasicMap();
        this.loadGamble().then();
        this.refreshCollect();
        O1HD.on(MessageEventKind.EventName.REFERSH_TREASURE_MAP_COLLECT, this.refreshCollect, this);
        O1HD.on(MessageEventKind.EventName.TREASURE_MAP_COLLECT_ANI, this.treasureMapCollectAni, this);

        
        // let chatId = '50';
        // let ariseLink = NormalGameManager._instance.getGameData().ariseLinks;
        // if (!ariseLink.includes(chatId)) {
        //     NormalGameManager._instance.addOneWeChatTriggerLink(chatId);
        // }
    }

    async loadGamble(){
        await this.loadConfigs();
        this.loadSaveGambler();
    }

    // 4 选 3
    // 3 选 3
    // 3 选 2
    // 2 选 2

    async loadConfigs(){
        return new Promise<void>(async resolve=>{
            let configArys:string[] = [
                // "gamblerGameUi/config/gamblerGameEventConfig",
                "gamblerGameUi/config/gamblerGameStartConfig",
                // "gamblerGameUi/config/gamblerGameEndLuckyConfig"
            ]

            if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
                configArys.push("gamblerGameUi/config/gamblerGameEndConfigH5");
            } else {
                configArys.push("gamblerGameUi/config/gamblerGameEndConfig");
            }
            let bundle = await getOneBundle(BUNDLE_SMALL_NAME.gamblerGameBundle);
            bundle.load( configArys,cc.JsonAsset,(err,asset:cc.JsonAsset[])=>{
                if(err){
                    console.log("加载gambler配置表失败",err);
                    this.gamblerEndMap = {};
                    return;
                }
                // this.gamblerEventJson = asset[0].json;
                this.gamblerStartJson = asset[0].json;
                this.gamblerEndJson   = asset[1].json;
                // this.gamblerLuckyEndJson = asset[3].json;

                // this.gamblerEventMap = asset[0].json;
                // this.gamblerEndJson = asset[2].json;

                // for(let item of this.gamblerEventJson){
                //     this.gamblerEventMap[item.id] = item;
                // }

                for(let item of this.gamblerEndJson){
                    item = JSON.parse(JSON.stringify(item));
                    this.gamblerEndMap[item.id] = item;
                    if(item["Emergency"] == ""){
                        item["Emergency"] = [];
                    }else{
                        let s = item["Emergency"];
                        item["Emergency"] = JSON.parse(s);
                    }
                }

                // for(let item of this.gamblerLuckyEndJson){
                //     item = JSON.parse(JSON.stringify(item));
                //     this.gamblerLuckyEndMap[item.id] = item;
                //     if(item["Emergency"] == ""){
                //         item["Emergency"] = [];
                //     }else{
                //         let s = item["Emergency"];
                //         item["Emergency"] = JSON.parse(s);
                //     }
                // }

                for( let item of this.gamblerStartJson ){
                    //循环记录
                    let infoEntity : { id : number ,Gear : number , weight : number,explain:string , price:number } = {
                        id : item['id'],
                        Gear : item["Gear"],
                        weight : item["weight"],
                        explain : item["explain"],
                        price : item["price"],
                    };
                    let basicEntity : GamblerBasicI = {
                        icon : item["icon"],
                        infoArray : [infoEntity]
                    };
                    //封装属性
                    if ( this.gamblerStartMap [ item["Gear"]] ) {
                        //如果存在
                        let gamblerBasicEntity = this.gamblerStartMap[item["Gear"]].find(( tempItem ,index ,dataList )=>{
                            return tempItem.icon == item["icon"];
                        });

                        if ( gamblerBasicEntity ) {
                            gamblerBasicEntity.infoArray.push( infoEntity );
                        }else{
                            this.gamblerStartMap[ item["Gear"]].push( basicEntity );
                        }
                    }else{
                        this.gamblerStartMap[item["Gear"]] = [];
                        this.gamblerStartMap[item["Gear"]].push( basicEntity );
                    }
                }
                //转换配置文件
                // console.log('gamblerStartJson', this.gamblerStartMap);
                resolve();
            });
        });
    }

    async loadGamblerObjs(){
        this.loadLayoutObj();
        // await this.loadOneLayoutObj();
        // await this.loadTwoLayoutObj();
        // await this.loadThreeLayoutObj();
        // await this.loadEndLayoutObj();
    }

    //出现过的素材id
    ariseMaterialIds:string[] = [];

    loadSaveLayoutObj(){
        let objAry:{startObj:gamblerStartInterface,endObj:gamblerEndInterface}[][] = this.objAry;
        for(let i = 0;i<objAry.length;i++){
            let o = objAry[i];
            for(let j = 0;j<o.length;j++){
                let data = objAry[i][j];
                if(data){
                    let objNode:cc.Node = cc.instantiate(this.objPrefab);
                    let os = objNode.getComponent(gamblerGameObj);
                    let isHaveBiao:boolean = true;
                    // if(i < 2){
                    //     isHaveBiao = false;
                    // }
                    os.bindDate(data.startObj,data.endObj,this,isHaveBiao);
                    let vec2 = this.vecAry[i][j];
                    objNode.setPosition(vec2);
                    objNode.setParent(this.objLayout);
                }
            }
        }
    }

    spliceOneSaveObj(obj:cc.Node){
        if(obj && obj.isValid){
            let os = obj.getComponent(gamblerGameObj);
            let startData = os.startData;
            let endData = os.endData;

            for(let i = 0;i<this.objAry.length;i++){
                let a = this.objAry[i];
                for(let j =0;j<a.length;j++){
                   let b = a[j];
                    if(JSON.stringify(b.startObj) == JSON.stringify(startData) && JSON.stringify(b.endObj) == JSON.stringify(endData)){
                        a.splice(j,1);
                    }
                }
            }
        }
        this.writeOneSaveObj();
    }

    writeOneSaveObj(){
        O1HD.getServices().localStorageSrv.setStorage(this.gamblerSaveKey,JSON.stringify(this.objAry));
    }
    
    refreshCollect() {
        let arr = TreasureMapCollect;
        let gameData = NormalGameManager._instance.getGameData();
        let treasureMap = gameData.treasureMap
        let children = this.nodeCollect.children;
        for (let i = 0; i < arr.length; i++) {
            children[i].active = treasureMap[i] ? true : false;
        }
    }

    treasureMapCollectAni(idx: number, pos: cc.Vec2) {
        let children = this.nodeCollect.children;
        let item = children[idx];
        let oScale = item.scale;
        let tPos = item.getPosition();
        let itemNode = cc.instantiate(item);
        itemNode.active = true;
        itemNode.scale = 1;
        itemNode.parent = this.nodeCollect;

        let sPos = this.nodeCollect.convertToNodeSpaceAR(pos);
        itemNode.setPosition(sPos);

        cc.tween(itemNode)
        .to(0.6, {x: tPos.x, y: tPos.y})
        .start();
        cc.tween(itemNode)
        .to(0.6, {scale: oScale})
        .call(()=> {
            item.active = true;
        })
        .removeSelf()
        .start();

    }


    onClickCollect() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        // let count = 0;
        // let gameData = NormalGameManager._instance.getGameData();
        // gameData.nvWaStore.forEach((v)=> {
        //     if (v) {
        //         count++;
        //     }
        // });
        O1HD.getModules().uiControlModule.showLoading();
        utilsView.openPopupLayer(
            'gamblerGame/OpenTreasureMapCollectLayer'
            , BUNDLE_SMALL_NAME.gamblerGameBundle
            , null
            , null
            , null
            , null
            , false
        );

        // if (count >= TreasureMapCollect.length) {
        //     // utilsView.openPopupLayerTwo(
        //     //     FileKind.PrefabFilePath.OpenOreCollectLayer
        //     // );
        // } else {
        //     O1HD.getModules().uiControlModule.showMessageBox('似乎有什么神秘功能');
        // }
    }

    async loadLayoutObj(){
        // for(let i =0;i<1;i++){
        //     let objId = 1 //Math.floor(Math.random() * 3 + 1);
        //     let startObj = this.gamblerStartMap[objId];
        //     let objNode:cc.Node = cc.instantiate(this.objPrefab);
        //     objNode.setParent(this.oneLayout);
        //     let os = objNode.getComponent(gamblerGameObj);
        //     let endObj = this.getOneTypeEnd(objId);
        //     console.log(startObj,"开始icon")
        //     // os.bindDate(startObj,endObj,this);
        //     // this.ariseMaterialIds.push(startObj.icon);
        // }
        let createCountAry:number[] = [3,3,2,1];
        let priceRate = NormalGameManager._instance.getPriceRate();
        for(let i =0;i<createCountAry.length;i++){
            let objAry:GamblerBasicI[] = this.gamblerStartMap[i + 1];
            let createCount:number = createCountAry[i];
            let indexAry:number[] = [];
            this.objAry[i] = [];
            for(let j = 0;j<createCount;j++){
                let randIndex:number = Math.floor(Math.random()*objAry.length);
                while(indexAry.includes(randIndex)){
                    randIndex = Math.floor(Math.random()*objAry.length);
                }
                indexAry.push(randIndex);
                let obj = data_control.getRandItemOfArray(objAry[randIndex].infoArray);
                let objNode:cc.Node = cc.instantiate(this.objPrefab);
                let os = objNode.getComponent(gamblerGameObj);
                let endObj = this.getOneTypeEnd(obj.id);
                let startObj:gamblerStartInterface = {
                    id: obj.id,
                    icon: objAry[randIndex].icon,
                    gear: i+1,
                    weight: obj.weight,
                    explain: obj.explain,
                    price: Math.floor(obj.price * priceRate)
                }
                let isHaveBiao:boolean = true;
                // if(i < 2){
                //     isHaveBiao = false;
                // }
                os.bindDate(startObj,endObj,this,isHaveBiao);
                this.objAry[i][j] = <{startObj:gamblerStartInterface,endObj:gamblerEndInterface}>{};
                this.objAry[i][j].startObj = startObj;
                this.objAry[i][j].endObj = endObj;
                let vec2 = this.vecAry[i][j];
                objNode.setPosition(vec2);
                objNode.setParent(this.objLayout);
            }
        }
        this.writeOneSaveObj();
    }

    getOneTypeEnd(type:number){
        let iType:string = type.toString();
        let endAry:gamblerEndInterface[] = [];
        for(let k in this.gamblerEndMap){
            let end = this.gamblerEndMap[k];
            if(end.ys_id == iType){
                endAry.push(end);
            }
        }
        let weightAry:number[] = [];
        for(let i =0;i<endAry.length;i++){
            let end = endAry[i];
            let endPro = end.pro;
            weightAry.push(endPro);
        }
        let index = data_control.getRandIPosByWeights(weightAry);
        return endAry[index];
    }

    @property({type:cc.Prefab,displayName:"锯木头预制体"})
    cutPrefab:cc.Prefab = null;

    cutPage:cc.Node = null;

    //开始锯某个木头
    startCutObj(obj:cc.Node){
        this.spliceOneSaveObj(obj);
        let cutNode:cc.Node = cc.instantiate(this.cutPrefab);
        let cs = cutNode.getComponent(gamblerCut);
        cs.bindNode(obj,this);
        cutNode.setParent(this.node);
    }

    @property({type:cc.Prefab,displayName:"描述界面"})
    explainPrefab:cc.Prefab = null;

    startExplain(objNode:cc.Node){
        let explainPage:cc.Node = cc.instantiate(this.explainPrefab);
        let es = explainPage.getComponent(gamblerExplain);
        es.bindData(objNode,this);
        explainPage.setParent(this.node);
    }

    @property({type:cc.Prefab,displayName:"结算界面"})
    cleanPrefab:cc.Node = null;

    cleanPage:cc.Node = null;

    showClean(obj:cc.Node){
        let cleanNode:cc.Node = cc.instantiate(this.cleanPrefab);
        let cs = cleanNode.getComponent(gamblerGameClean);
        cs.bindNode(obj,this);
        cleanNode.setParent(this.node);
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.node.removeFromParent();
        this.node.destroy();
    }

    onBtnStock(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.objLayout.destroyAllChildren();
            this.objLayout.removeAllChildren();
            this.loadGamblerObjs();
        },()=>{

        },null,"点木成金模式重新进货")
    }

    oneNodeBack(obj:cc.Node){
        obj.setParent(this.objLayout);
        obj.setPosition(obj.getComponent(gamblerGameObj).initPos);
    }

    saveLuckyNum(luckyNum:number){
       
    }

    updateLuckyProgress(hasAni:boolean = true){
       
    }

    async addLuckyAni(){
       
    }

    tipsAni(){
       
    }

    onBtnTips(){
       
    }

}

/**
 * 基础Map
 */
export class GamblerBasicMap {
    [ gear : number] : GamblerBasicI[];
}
//基础接口
export interface GamblerBasicI {
    icon : string;
    infoArray : { id : number,Gear : number,weight : number,explain:string,price:number}[],
}






